import get from "lodash/get"
import axios from "axios"
import * as ActionTypes from "constants-lib/actionTypes"
import { urls } from "utils-lib/builds"
import { getWindow } from "utils-lib/getWindow"
import getReCaptchaConfig from "utils-lib/getCaptchaConfig"

const getRecaptchaDetails = async (action) => {
  const ssrWindow = getWindow()

  if (!ssrWindow?.grecaptcha?.enterprise) return {}
  const siteKey = getReCaptchaConfig()

  try {
    return await new Promise((resolve, reject) => {
      ssrWindow.grecaptcha.enterprise.ready(async () => {
        try {
          const token = await ssrWindow.grecaptcha.enterprise.execute(siteKey, {
            action,
          })

          resolve({
            recaptchaToken: token,
            recaptchaAction: action,
          })
        } catch (error) {
          reject(error)
        }
      })
    })
  } catch (error) {
    return {}
  }
}

export const pendingAC = () => ({
  type: ActionTypes.CREATE_USER_WITH_CREDENTIALS_PENDING,
})

export const failedAC = (data) => ({
  type: ActionTypes.CREATE_USER_WITH_CREDENTIALS_FAILED,
  payload: data,
})

export const fulfilledAC = (data) => ({
  type: ActionTypes.CREATE_USER_WITH_CREDENTIALS_FULFILLED,
  payload: data,
})

export const createUserWithCredentials = (data) => async (dispatch) => {
  const api = `CREATE_USER`
  const url = urls.url[api]
  dispatch(pendingAC())
  const { recaptchaToken, recaptchaAction } = await getRecaptchaDetails(
    `create_user`,
  )

  const config = {
    headers: {},
  }
  const apiKey = get(urls, `apiKey.USER[${api}]`, ``)
  if (apiKey !== ``) {
    config.headers.apiKey = apiKey
  }

  const requestData =
    recaptchaToken && recaptchaAction
      ? {
          ...data,
          recaptchaToken,
          recaptchaAction,
        }
      : data

  return axios
    .create(config)
    .post(url, requestData)
    .then((response) => {
      const login = get(response, `data.data.profile.login`, ``)
      const errorMsg = get(response, `data.errorMsg`, ``)
      const statusCode = get(response, `data.statusCode`, ``)
      dispatch(fulfilledAC({ login, errorMsg, statusCode }))
      return response
    })
    .catch((error) => {
      const errorCode = get(error, `response.status`, ``)
      const errorMsg = get(error, `response.data.errorMsg`, ``)
      const statusCode = get(error, `response.data.statusCode`, ``)
      dispatch(failedAC({ errorCode, errorMsg, statusCode }))
      return error
    })
}
